import type { LiveCodeBlockAttributes } from "./type";

export const DEFAULT_ATTRIBUTES: LiveCodeBlockAttributes = {
  codeStack: null,
  data: null,
  caption: null,
};

export const EXTENSION_NAME = "liveCodeBlock";
